import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Box } from '@material-ui/core';
import Button from '../Button';

const FiltersCallToAction = ({
  classes,
  saveLabel,
  saveLabelHover,
  clearLabel,
  onSave,
  onClear,
  clearButtonDisabled,
  buttonClass,
}) => (
  <Box className={classes.container}>
    <Button
      variant="outlined"
      onClick={onClear}
      data-testid="filters-call-to-action-options-clear"
      disabled={clearButtonDisabled}
      className={buttonClass}
    >
      {clearLabel}
    </Button>
    <Button
      onClick={onSave}
      data-testid="filters-call-to-action-options-save"
      className={cx(classes.saveButton, buttonClass)}
    >
      <span className={classes.onHoverHide}>{saveLabel}</span>
      <span className={classes.onHoverShow}>{saveLabelHover || saveLabel}</span>
    </Button>
  </Box>
);

FiltersCallToAction.propTypes = {
  classes: PropTypes.shape({}),
  saveLabel: PropTypes.string,
  clearLabel: PropTypes.string,
  clearButtonDisabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  buttonClass: PropTypes.string,
};

FiltersCallToAction.defaultProps = {
  classes: {},
  saveLabel: 'Save',
  clearLabel: 'Clear',
};

export default FiltersCallToAction;
